import {
  AUTHORIZED_MODULE,
  NOTIFICATION,
  SYSTEM_MODULE,
  DASHBOARD_MODULE,
  SESSION_MODULE,
  ZONES_MODULE,
  SYSTEM_EVENTS_MODULE,
  SETTINGS_MODULE,
  METROLOGY_MODULE,
  DETECTION_MODULE,
  WEB_SOCKET_MODULE,
} from '../configs/moduleNames';

import System from './System';
import Authorized from './Authorized';
import Dashboard from './Dashboard';
import Notifications from './Notifications';
import Session from './Session';
import Zones from './Zones';
import SystemEvents from './SystemEvents';
import Settings from './Settings';
import Metrology from './Metrology';
import Detection from './Detection';
import WebSocket from './WebSocket';

const modules = {
  [SYSTEM_MODULE]: System,
  [AUTHORIZED_MODULE]: Authorized,
  [NOTIFICATION]: Notifications,
  [DASHBOARD_MODULE]: Dashboard,
  [DETECTION_MODULE]: Detection,
  [SESSION_MODULE]: Session,
  [ZONES_MODULE]: Zones,
  [SYSTEM_EVENTS_MODULE]: SystemEvents,
  [SETTINGS_MODULE]: Settings,
  [METROLOGY_MODULE]: Metrology,
  [WEB_SOCKET_MODULE]: WebSocket,

};

export default modules;
